<template>
  <div class="mb-page">
    <Card title="会员权益设置">
      <Form :label-width="120" v-if="form">
        <FormItem label="启用会员价">
          <i-switch v-model="form.member_price_enabled" />
          <span class="hint">关闭后结算不再套用商品会员价。团队差异化折扣请到「营销管理 → 权益卡」。</span>
        </FormItem>
        <FormItem label="页面标题">
          <Input
            v-model="form.page_title"
            clearable
            placeholder="可留空；留空则小程序不显示该标题"
            style="width: 320px"
          />
          <div class="hint">仅展示用，允许为空。</div>
        </FormItem>
        <FormItem label="简介">
          <Input
            v-model="form.intro"
            type="textarea"
            :rows="3"
            clearable
            placeholder="可留空；留空则小程序不展示简介"
          />
          <div class="hint">允许为空。产品说明可写在下方权益条目里。</div>
        </FormItem>
        <Divider orientation="left">权益条目</Divider>
        <div v-for="(b, i) in form.benefits" :key="'b-' + i" class="benefit-row">
          <Input v-model="b.title" placeholder="标题" style="width: 180px" />
          <Input v-model="b.desc" placeholder="说明" style="width: 360px; margin-left: 8px" />
          <i-switch v-model="b.enabled" class="m-l-10" />
          <Button type="text" @click="form.benefits.splice(i, 1)">删除</Button>
        </div>
        <Button type="dashed" long class="m-t-8" @click="addBenefit">添加权益</Button>
        <div class="m-t-16">
          <Button type="primary" :loading="saving" @click="save">保存</Button>
          <Button class="m-l-10" @click="load">刷新</Button>
        </div>
      </Form>
    </Card>
  </div>
</template>

<script>
import { memberBenefitGet, memberBenefitSave } from '@/api/storedValue'

export default {
  name: 'MemberBenefits',
  data() {
    return {
      saving: false,
      form: {
        member_price_enabled: true,
        page_title: '',
        intro: '',
        benefits: [],
      },
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    addBenefit() {
      this.form.benefits.push({ title: '', desc: '', enabled: true })
    },
    async load() {
      try {
        const res = await memberBenefitGet()
        if (res.data && res.data.code === 200 && res.data.data) {
          this.form = {
            member_price_enabled: res.data.data.member_price_enabled !== false,
            page_title: res.data.data.page_title != null ? String(res.data.data.page_title) : '',
            intro: res.data.data.intro != null ? String(res.data.data.intro) : '',
            benefits: Array.isArray(res.data.data.benefits) ? res.data.data.benefits.map((b) => ({
              title: b.title || '',
              desc: b.desc || '',
              enabled: b.enabled !== false,
            })) : [],
          }
        }
      } catch (e) {
        this.$Message.error(e.message || '加载失败')
      }
    },
    async save() {
      this.saving = true
      try {
        const payload = {
          member_price_enabled: !!this.form.member_price_enabled,
          page_title: this.form.page_title != null ? String(this.form.page_title) : '',
          // 明确允许空字符串
          intro: this.form.intro != null ? String(this.form.intro) : '',
          benefits: Array.isArray(this.form.benefits) ? this.form.benefits : [],
        }
        const res = await memberBenefitSave(payload)
        if (res.data && res.data.code === 200) {
          this.$Message.success('保存成功')
          this.load()
        } else {
          this.$Message.error((res.data && res.data.msg) || '保存失败')
        }
      } catch (e) {
        this.$Message.error(e.message || '保存失败')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.benefit-row { display: flex; align-items: center; margin-bottom: 8px; }
.m-l-10 { margin-left: 10px; }
.m-t-8 { margin-top: 8px; }
.m-t-16 { margin-top: 16px; }
.hint { margin-left: 8px; color: #999; font-size: 12px; }
</style>
